import type { Computed } from 'easy-peasy';
import { computed } from 'easy-peasy';
import { carrierColorMap, BASE_KEY } from './carrierColorMap';
export interface ThemeModel {
  getServiceMethodReportColor: Computed<ThemeModel, (serviceMethodId: string, opacity?: number) => string>;
  getCarrierReportColor: Computed<ThemeModel, (serviceMethodId: string, opacity?: number) => string>;
}
// create a random but consistent color code (IE lso would always show as same color)
const generateRandomHexColor = (str: string) => {
  let color = '#';
  const letters = '0123456789ABCDEF';
  for (let i = 0; i < 6; i++) {
    color += letters[str.charCodeAt(i % str.length) % letters.length];
  }
  return color;
};
const intToHex = (i: number) => {
  const hexDig = ['A', 'B', 'C', 'D', 'E', 'F'];
  if (i < 10) {
    return String(i);
  }
  return hexDig[i - 10];
};
const convertDecimalOpacityToHex = (decimal: number) => {
  if (decimal > 1 || decimal < 0) {
    return '00';
  }
  const standardizedDecimal = decimal * 255;
  const dig1 = Math.round(standardizedDecimal % 16);
  const r = Math.round((standardizedDecimal - dig1) / 16);
  return intToHex(r % 16) + intToHex(dig1);
};
export const themeModel: ThemeModel = {
  getCarrierReportColor: computed(() => {
    return (carrier: string, opacity?: number) => {
      return (
        (carrierColorMap[carrier][BASE_KEY] || generateRandomHexColor(carrier)) +
        convertDecimalOpacityToHex(opacity || 0)
      );
    };
  }),
  getServiceMethodReportColor: computed(() => {
    const colorMap: Record<string, string> = {};
    for (const curr of Object.values(carrierColorMap)) {
      Object.assign(colorMap, curr);
    }
    return (serviceMethodId: string, opacity?: number) => {
      return (
        (colorMap[serviceMethodId] || generateRandomHexColor(serviceMethodId)) +
        convertDecimalOpacityToHex(opacity || 0)
      );
    };
  }),
};
